import { Trans } from "react-i18next";
import { twJoin } from "tailwind-merge";

import { Price } from "@onsite_app/MobileOrderingMenu/Atoms";

import { VoucherTemplate } from "./schema";

export const VoucherPricing = ({
  priceInCents,
  valueInCents,
}: {
  priceInCents: number;
  valueInCents: number;
}) => {
  const isDiscounted = valueInCents > priceInCents;
  const hasSurcharge = priceInCents > valueInCents;
  return (
    <div className="text-right">
      <div className="flex items-baseline justify-end space-x-4 text-2xl font-bold">
        {isDiscounted && (
          <div className="inline-block text-base font-normal line-through opacity-60">
            <Price fromCents value={valueInCents} showCurrency />
          </div>
        )}
        <div>
          <Price fromCents value={priceInCents} showCurrency />
        </div>
      </div>
      {isDiscounted && (
        <span className="inline-block text-base font-normal opacity-60">
          <Trans
            i18nKey="vouchers.voucherTemplates.voucherSavings"
            components={{
              Value: (
                <Price
                  value={valueInCents - priceInCents}
                  fromCents
                  showCurrency
                />
              ),
            }}
          />
        </span>
      )}
      {hasSurcharge && (
        <div className="inline-block text-base font-normal opacity-60">
          <Trans
            i18nKey="vouchers.voucherTemplates.voucherSurcharge"
            components={{
              Value: (
                <Price
                  value={priceInCents - valueInCents}
                  fromCents
                  showCurrency
                />
              ),
            }}
          />
        </div>
      )}
    </div>
  );
};
export const VoucherTemplateCard = ({
  voucherTemplate,
}: {
  voucherTemplate: VoucherTemplate;
}) => {
  return (
    <div className="border-venue rounded-venue-brand border-venue-brand-lg border-venue-primary bg-venue-tertiary p-24 text-venue-primary shadow-venue-brand-style-lg">
      <div
        className={twJoin(
          "flex justify-between",
          voucherTemplate.marketingDescription ? "items-start" : "items-center",
        )}
      >
        <div className="flex-1 space-y-4">
          {voucherTemplate.name && (
            <h2 className="text-xl font-bold">{voucherTemplate.name}</h2>
          )}
          <h2 className="text-4xl font-bold">
            <Trans
              i18nKey="vouchers.voucherTemplates.voucherName"
              components={{
                Name: <span className="text-2xl font-normal" />,
                Value: (
                  <Price
                    showCurrency
                    fromCents
                    value={voucherTemplate.valueInCents}
                  />
                ),
              }}
            />
          </h2>
        </div>
        {voucherTemplate.priceInCents !== voucherTemplate.valueInCents && (
          <div className="flex items-center">
            <VoucherPricing
              priceInCents={voucherTemplate.priceInCents}
              valueInCents={voucherTemplate.valueInCents}
            />
          </div>
        )}
      </div>
      {voucherTemplate.marketingDescription && (
        <div className="mt-16 whitespace-pre-line">
          {voucherTemplate.marketingDescription}
        </div>
      )}
    </div>
  );
};
